import * as React from 'react';
import styled from 'styled-components';
import { AvatarMultiGrammar } from './AvatarMultiGrammar';
import { horizontalSpace, verticalSpace } from '@doltech/utils/lib/css-style';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import { IconSystemV2PeopleOutlineUserGroup } from '@doltech/icons/SystemV2/IconSystemV2PeopleOutlineUserGroup';

const Main = styled.div`
  width: 100%;
  ${verticalSpace(8)};
`;

const More = styled.div`
  display: flex;
  align-items: center;
  ${horizontalSpace(6)};
`;

interface ViewMultiStudentsProps extends React.HTMLAttributes<HTMLDivElement> {
  users?: any[];
  maxCount?: number;
  type?: 'theory' | 'exercise';
}

export const ViewMultiStudents = (props: ViewMultiStudentsProps) => {
  const { users, type, maxCount } = props;
  return (
    <Main className="view-multi-students">
      <AvatarMultiGrammar
        users={users?.map((eachUser) => {
          const userInfo = eachUser?.userInfo;
          const { userId, picture } = userInfo || {};
          return {
            userId,
            avatarUrl: picture,
          };
        })}
        avatarSize={32}
        maxCount={maxCount}
        seeMoreType="none"
      />
      <More>
        <IconSystemV2PeopleOutlineUserGroup size={16} color="gray120"/>
        <ResponsiveTypography.Paragraph variant="Regular/Medium - Compact" color="gray120">
          {type === 'theory' ? 'nhiều bạn đã đọc bài' : 'nhiều bạn đã làm bài'}
        </ResponsiveTypography.Paragraph>
      </More>
    </Main>
  );
};
